import React, { useState } from 'react';
import Header from '../components/Header';
import BookRide from '../components/BookRide';
import Footer from '../components/Footer';
import './Contact.css';

const initialForm = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  interest: 'Narsimha',
  message: '',
};

function Contact() {
  const [form, setForm] = useState(initialForm);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    // hook up to your contact endpoint here
  };

  return (
    <div>
      <Header />

      {/* ── Page header ── */}
      <section className="contact-hero">
        <h1 className="contact-hero__heading">Contact us</h1>
        <p className="contact-hero__sub">
          Any question? We would be happy to help you!
        </p>
      </section>

      {/* ── Form ── */}
      <section className="contact-form-wrap">
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="contact-form__row">
            <div className="contact-form__field">
              <label className="contact-form__label" htmlFor="firstName">First Name</label>
              <input
                id="firstName"
                type="text"
                name="firstName"
                placeholder="John"
                value={form.firstName}
                onChange={handleChange}
                className="contact-form__input"
                required
              />
            </div>
            <div className="contact-form__field">
              <label className="contact-form__label" htmlFor="lastName">Last Name</label>
              <input
                id="lastName"
                type="text"
                name="lastName"
                placeholder="Wick"
                value={form.lastName}
                onChange={handleChange}
                className="contact-form__input"
              />
            </div>
          </div>

          <div className="contact-form__row">
            <div className="contact-form__field">
              <label className="contact-form__label" htmlFor="email">Email ID</label>
              <input
                id="email"
                type="email"
                name="email"
                placeholder="ceo@acriolisindiamotors.com"
                value={form.email}
                onChange={handleChange}
                className="contact-form__input"
                required
              />
            </div>
            <div className="contact-form__field">
              <label className="contact-form__label" htmlFor="phone">Phone Number</label>
              <input
                id="phone"
                type="tel"
                name="phone"
                placeholder="+91 99582 53628"
                value={form.phone}
                onChange={handleChange}
                className="contact-form__input"
              />
            </div>
          </div>

          <div className="contact-form__field">
            <label className="contact-form__label" htmlFor="interest">I'm interested in</label>
            <select
              id="interest"
              name="interest"
              value={form.interest}
              onChange={handleChange}
              className="contact-form__input contact-form__select"
            >
              <option>Narsimha</option>
              <option>Defence</option>
              <option>Research</option>
              <option>Investment</option>
              <option>Other</option>
            </select>
          </div>

          <div className="contact-form__field">
            <label className="contact-form__label" htmlFor="message">Enter your details</label>
            <textarea
              id="message"
              name="message"
              rows="5"
              placeholder="Tell us how we can help…"
              value={form.message}
              onChange={handleChange}
              className="contact-form__input contact-form__textarea"
            />
          </div>

          <button type="submit" className="contact-form__btn">
            Send Message <span>→</span>
          </button>
        </form>
      </section>

      <BookRide />
      <Footer />
    </div>
  );
}

export default Contact;
